module.exports = __webpack_public_path__ + "img/bg.95e96a1a.jpg";